/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { Route } from "react-router";
import { AdminRoutes } from "../admin";
import ProtectedRoute from "../../shared/ProtectedRoute";
import DashboardAdmin from "../../features/dashboard/DashboardAdmin";
import Employees from "../../features/employees/Employees";
import AddEmployee from "../../features/employees/AddEmployee";
import Activity from "../../features/activity/Activity";
import Absents from "../../features/dashboard/testDashboard/AdminDahboardComponents/Absents";
import UpdateEmployee from "../../features/employees/UpdateEmployee";
import ViewEmployee from "../../features/employees/ViewEmployee";
import Holidays from "../../features/holidays/Holidays";
import AddHolidays from "../../features/holidays/AddHolidays";
import AllLeaveRequests from "../../features/leave-request/AllLeaveRequests";
import UpdateLeaveRequest from "../../features/leave-request/UpdateLeaveRequest";
import FileUploadForm from "../../features/file-manager/UploadFile";
import TimeTracker from "../../features/time-tracker/TimeTracker";
import ManageTimeTrackers from "../../features/time-tracker/ManageTimeTrackers";
import ViewTimeTrackers from "../../features/time-tracker/ViewTimeTrackers";
import UncompletedTimeTrackers from "../../features/dashboard/testDashboard/AdminDahboardComponents/UncompletedTimeTrackers";
import { useSelector } from "react-redux";
import { selectLoggedUser } from "../../data/store/authSlice";
import { store } from "../../data/store/store";
import {
  appEndpoints,
  useLazyGetHolidaysQuery,
} from "../../data/endpoints/app.endpoints";
import { selectEmployeeSliceState } from "../../data/store/employeeSlice";
import { UserRole } from "../../utils/enums/user-role.enum";
import PageNotFound from "../Errors/PageNotFound";
import Vehicles from "../../features/vehicles/Vehicles";
import AddVehicle from "../../features/vehicles/AddVehicle";
import VehicleInsights from "../../features/vehicles/VehicleInsights";
import { selectLeavesState } from "../../data/store/leaveRequestSlice";
import LeaveCalendar from "../../features/overview-calendar/LeaveCalendar";
import moment from "moment";
import UpdateVehicle from "../../features/vehicles/UpdateVehicle";
import { selectVehicleSliceState } from "../../data/store/vehicleSlice";
import FileSystem from "../../features/file-manager/FileSystem";
interface UseAdminRoutesProps {
  refreshToken: string;
}

const useAdminRoutes = ({ refreshToken }: UseAdminRoutesProps) => {
  const user = useSelector(selectLoggedUser);

  const { isLoading: isLoadingEmployees } = useSelector(
    selectEmployeeSliceState
  );

  const { isLoading: isLoadingVehicles } = useSelector(selectVehicleSliceState);
  const { isLoading: isLoadingLeaves } = useSelector(selectLeavesState);

  const [getHolidays, holidaysResult] = useLazyGetHolidaysQuery();

  const { isLoading: isLoadingHolidays } = holidaysResult;

  useEffect(() => {
    if (user?.userId && user.role === UserRole.ADMIN) {
      store.dispatch(
        appEndpoints.endpoints.getPaginatedUsers.initiate({
          currentPage: 1,
          limitTo: 10,
        })
      );

      store.dispatch(appEndpoints.endpoints.getAllUsers.initiate(true));
      store.dispatch(
        appEndpoints.endpoints.getAllLeaves.initiate({
          currentPage: 1,
          limitTo: 10,
        })
      );

      store.dispatch(
        appEndpoints.endpoints.getAdminDashboard.initiate(undefined)
      );
      const selectedDate = moment().format();
      const endYear = moment(selectedDate).endOf("year").format();
      const startYear = moment(selectedDate).startOf("year").format();
      store.dispatch(
        appEndpoints.endpoints.getHolidays.initiate({
          startDate: startYear,
          endDate: endYear,
        })
      );
    }
  }, [user?.userId]);

  return (
    <Route element={<AdminRoutes refreshToken={refreshToken} />}>
      <Route
        path="dashboard"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={!user?.userId}
            Component={DashboardAdmin}
          />
        }
      />
      <Route
        path="employees"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={Employees}
          />
        }
      />
      <Route
        path="add-user"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={AddEmployee}
          />
        }
      />
      <Route
        path="vehicles"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={Vehicles}
          />
        }
      />
      <Route
        path="add-vehicle"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={AddVehicle}
          />
        }
      />
      <Route
        path="vehicle-insights"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={VehicleInsights}
          />
        }
      />
      <Route
        path="edit-vehicle/:id"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={UpdateVehicle}
          />
        }
      />
      <Route
        path="vehicle"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={Vehicles}
          />
        }
      />
      <Route
        path="add-vehicle"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={AddVehicle}
          />
        }
      />
      <Route
        path="edit-vehicle/:id"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingVehicles && !!user}
            Component={UpdateVehicle}
          />
        }
      />
      <Route
        path="vehicle-insights"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={VehicleInsights}
          />
        }
      />
      <Route
        path="activity"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={Activity}
          />
        }
      />
      <Route
        path="absents"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={Absents}
          />
        }
      />

      <Route
        path="edit-user/:id"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={UpdateEmployee}
          />
        }
      />
      <Route
        path="view-user/:id"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={ViewEmployee}
          />
        }
      />
      <Route
        path="holidays"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingHolidays}
            Component={Holidays}
          />
        }
      />
      <Route
        path="add-holiday"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingHolidays}
            Component={AddHolidays}
          />
        }
      />
      <Route
        path="leave-requests"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={!user}
            Component={AllLeaveRequests}
          />
        }
      />

      <Route
        path="leave-requests/:status"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={!user && isLoadingLeaves}
            Component={AllLeaveRequests}
          />
        }
      />

      <Route
        path="overview-calendar"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingHolidays}
            Component={LeaveCalendar}
          />
        }
      />
      <Route
        path="leaves/update/:id"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingLeaves}
            Component={UpdateLeaveRequest}
          />
        }
      />
      <Route
        path="manage-time-trackers"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={ManageTimeTrackers}
          />
        }
      />
      <Route
        path="uncomplete-time-trackers"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={UncompletedTimeTrackers}
          />
        }
      />
      <Route
        path="view-time-trackers"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={ViewTimeTrackers}
          />
        }
      />

      <Route
        path="manage-time-trackers/create-time-tracker/:id/:date"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={TimeTracker}
          />
        }
      />
      <Route
        path="file-manager/upload/*"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={FileUploadForm}
          />
        }
      />
      <Route
        path="file-manager/*"
        element={
          <ProtectedRoute
            isUserLoggedIn={!!refreshToken}
            loadingSpinnerCondition={isLoadingEmployees}
            Component={FileSystem}
          />
        }
      />
      <Route path="/*" element={<PageNotFound />} />
    </Route>
  );
};

export default useAdminRoutes;
